/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmClassifyClassify } from "../../funcs/llmClassifyClassify.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ClassifyTextRequest$inboundSchema,
};

export const tool$llmClassifyClassify: ToolDefinition<typeof args> = {
  name: "llm-classify-classify",
  description: `Classify text into predefined categories

Classifies text content into one of the provided predefined labels.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmClassifyClassify(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
